export const loadState = () => {
  try {
    const state = {
      refreshToken: localStorage.getItem('refreshToken') || '',
      token: localStorage.getItem('token') || '',
    }
    return state;
  } catch (err) {
    return undefined;
  }
};

export const changeToken = (state) => {
  try {
    if (state.token) localStorage.setItem('token', state.token);
    if (state.refreshToken) localStorage.setItem('refreshToken', state.refreshToken);
  } catch (err) {
    console.log(err)
  }
};
